export default __webpack_public_path__ + "static/media/zoom_in.ebaf02de.svg";